/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * Audius API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { TrackDownloadCountResponseData } from './TrackDownloadCountResponseData';
import {
    TrackDownloadCountResponseDataFromJSON,
    TrackDownloadCountResponseDataFromJSONTyped,
    TrackDownloadCountResponseDataToJSON,
} from './TrackDownloadCountResponseData';

/**
 * 
 * @export
 * @interface TrackDownloadCountResponse
 */
export interface TrackDownloadCountResponse {
    /**
     * 
     * @type {TrackDownloadCountResponseData}
     * @memberof TrackDownloadCountResponse
     */
    data: TrackDownloadCountResponseData;
}

/**
 * Check if a given object implements the TrackDownloadCountResponse interface.
 */
export function instanceOfTrackDownloadCountResponse(value: object): value is TrackDownloadCountResponse {
    let isInstance = true;
    isInstance = isInstance && "data" in value && value["data"] !== undefined;

    return isInstance;
}

export function TrackDownloadCountResponseFromJSON(json: any): TrackDownloadCountResponse {
    return TrackDownloadCountResponseFromJSONTyped(json, false);
}

export function TrackDownloadCountResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): TrackDownloadCountResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': TrackDownloadCountResponseDataFromJSON(json['data']),
    };
}

export function TrackDownloadCountResponseToJSON(value?: TrackDownloadCountResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': TrackDownloadCountResponseDataToJSON(value.data),
    };
}

